const typesPay = [
  {
    id: 'PT_CHARGE',
    value: 'Списание',
  },
  {
    id: 'PT_INCOME',
    value: 'Зачисление',
  },
  {
    id: 'PT_ADJUSTMENT',
    value: 'Корректировка',
  },
];

export default typesPay;
